import React from 'react';
import {connect} from 'react-redux';
import {setDefaultPaymentRadio} from '../../../common/paymentPopup/actions';

class PaymentSelect extends React.Component {

    static propTypes = {
        msg: React.PropTypes.object,
        defaultPaymentRadio: React.PropTypes.string,
        setDefaultPaymentRadio: React.PropTypes.func,
        paymentRadioTypes: React.PropTypes.object
    };

    render() {
        const {defaultPaymentRadio, setDefaultPaymentRadio, paymentRadioTypes, msg} = this.props;

        return (
            <div className="table-row">
              <div className="table-cell" style={{width: '55.55%'}}>
                <div className="boxBtn text-left text-black">
                    <div className="boxBtn-inner">
                      <div className="settings-name">
                        <span className="settings-name-name">{msg.settings.paymentInput.title}</span>
                      </div>
                    </div>
                </div>
              </div>
              <div className="table-cell" style={{width: '44.44%'}}>
                    <div className="switch">
                        <div
                            className={`switch-option text-l ${defaultPaymentRadio === paymentRadioTypes.DISCOUNT ? 'active' : ''} color-greenLight`}
                            onClick={() => setDefaultPaymentRadio(paymentRadioTypes.DISCOUNT)}>
                            <div className="switch-inner">
                                <span>{msg.settings.paymentInput.sale}</span>
                            </div>
                        </div>
                        <div
                            className={`switch-option text-l ${defaultPaymentRadio === paymentRadioTypes.DISCOUNT_CURRENCY ? 'active' : ''} color-greenLight`}
                            onClick={() => setDefaultPaymentRadio(paymentRadioTypes.DISCOUNT_CURRENCY)}>
                            <div className="switch-inner">
                                <span>{msg.settings.paymentInput.saleCurrency}</span>
                            </div>
                        </div>
                        <div
                            className={`switch-option text-l ${defaultPaymentRadio === paymentRadioTypes.MONEY_GIVEN ? 'active' : ''} color-greenLight`}
                            onClick={() => setDefaultPaymentRadio(paymentRadioTypes.MONEY_GIVEN)}>
                            <div className="switch-inner">
                                <span>{msg.settings.paymentInput.paid}</span>
                            </div>
                        </div>
                    </div>
              </div>
            </div>
        );

    }


}

export default connect(state => ({
    msg: state.intl.trans[state.intl.currentLocale],
    defaultPaymentRadio: state.paymentPopup.get('defaultPaymentRadio'),
    paymentRadioTypes: state.paymentPopup.get('paymentRadioTypes')
}), {setDefaultPaymentRadio})(PaymentSelect);



// WEBPACK FOOTER //
// ./src/browser/menu/settings/PaymentSelect.js